var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"sm-account__main"},[_c('div',{staticClass:"sm-wrap sm"},[_c('div',{staticClass:"sm-account__main-inner"},[_c('account',{attrs:{"userAccountProp":_vm.userAccount},on:{"callMethod":_vm.callMethod}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }